import * as React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Typography } from '@material-ui/core';
import { Logo } from '../common/Logo';
import { mainMenuItems } from '../common/utils';
const styles = (theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 180,
  },
  logoIcon: {
    width: 955,
    height: 384,
    opacity: 0.07,
  },
  logoTitle: {
    color: theme.palette.primary.main,
    fontSize: '2.25rem',
  },
  logoWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  menuItem: {
    color: theme.palette.primary.main,
    fontSize: '1.125rem',
  },
  menuItemContainer: {
    textAlign: 'center',
    width: theme.spacing.unit * 13,
  },
  menuContainer: {
    width: '80%',
    marginTop: 60,
    alignSelf: 'center',
  },
});

class HomePage extends React.PureComponent {
  static propTypes = {
    classes: PropTypes.any.isRequired,
    campusDistrictInfo: PropTypes.any,
    districtAdvancedSettings: PropTypes.object,
    init: PropTypes.func,
  };

  componentDidMount() {
    const { init, profile } = this.props;
    if (profile) {
      init(profile);
    }
    /*const script = document.createElement('script');
    script.src =
      'https://atxanka.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/zca20r/b/11/a44af77267a987a660377e5c46e0fb64/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=en-US&collectorId=af8bcc66';
    script.async = true;
    document.body.appendChild(script);
    script.onload = () => {
      window.ATL_JQ_PAGE_PROPS = {
        triggerFunction: (showCollectorDialog) => {
          document.getElementById('feedbackBtn').onclick = (e) => {
            e.preventDefault();
            showCollectorDialog();
          };
        },
      };
    };*/
  }

  componentDidUpdate(prevProps) {
    if (document.getElementById('atlwdg-trigger')) {
      document.getElementById('atlwdg-trigger').setAttribute('style', 'z-index: 10;');
    }
    const { profile, init } = this.props;
    // Call init when profile becomes available
    if (!prevProps.profile && profile) {
      init(profile);
    }
  }

  renderMenuItem = (key, menu) => {
    const { title, icon: Icon, link } = menu;
    const { classes } = this.props;
    return (
      <Link key={key} to={link} style={{ textDecoration: 'none' }}>
        <Grid item className={classes.menuItemContainer}>
          <Icon color="primary" fontSize="large" />
          <Typography align="center" gutterBottom className={classes.menuItem}>
            {title}
          </Typography>
        </Grid>
      </Link>
    );
  };
  getVisibleMenuItems = (menuItems, menusVisibility, profile) => {
    const featureFlags = (profile && profile.featureFlags) || {};
    return Object.keys(menuItems).reduce((filteredMenu, key) => {
      const item = menuItems[key];
      // Early-access items require a per-user flag set server-side.
      if (item.requiresUserFlag && featureFlags[item.requiresUserFlag] !== true) {
        return filteredMenu;
      }
      // If visibility is undefined, default to false (hidden)
      if (menusVisibility[key] !== false) {
        filteredMenu[key] = item;
      }
      return filteredMenu;
    }, {});
  };
  render() {
    const { classes, campusDistrictInfo, profile, districtAdvancedSettings } = this.props;
    let districtMenusVisibility = {};
    if (profile) {
      if (districtAdvancedSettings && districtAdvancedSettings.menusVisibility) {
        districtMenusVisibility = districtAdvancedSettings.menusVisibility;
      }
      if (profile.isSuperAdmin != true && profile.canViewAccountabilityReports != true) {
        districtMenusVisibility.reports = false;
        districtMenusVisibility.flightPlan = false;
      }
    }

    let menuItems;
    if (
      campusDistrictInfo &&
      (campusDistrictInfo.isDistrict || (campusDistrictInfo.gradeEnd && Number(campusDistrictInfo.gradeEnd) >= 9))
    ) {
      menuItems = mainMenuItems;
    } else {
      menuItems = Object.fromEntries(
        Object.entries(mainMenuItems).filter(([_, item]) => item.isVisibleToDistrictOnly !== true)
      );
    }

    //  Filter menus based on advanced settings
    menuItems = this.getVisibleMenuItems(menuItems, districtMenusVisibility, profile);

    return (
      <div className={classes.root}>
        <Logo
          isHomePage
          wrapperClassName={classes.logoWrapper}
          logoClassName={classes.logoIcon}
          titleClassName={classes.logoTitle}
        />
        <Grid
          container
          direction="row"
          justify="space-evenly"
          alignItems="flex-start"
          className={classes.menuContainer}
        >
          {Object.entries(menuItems).map(([key, menu]) => this.renderMenuItem(key, menu))}
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(HomePage);
